export default __webpack_public_path__ + "static/media/lattes-icon.28a9d1bd.svg";